import React from 'react';
import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import Navbar from './Navbar';
import './Dashboard.css';

const Dashboard = () => {
  const { user } = useContext(AuthContext);

  return (
    <div className="dashboard">
      <Navbar />
      <div className="dashboard-content">
        <div className="dashboard-header">
          <h1>Tableau de bord</h1>
          <p>Bienvenue, {user?.username}</p>
        </div>
        
        <div className="dashboard-cards">
          <Link to="/devis" className="dashboard-card">
            <div className="card-icon">📋</div>
            <h2>Demandes de devis</h2>
            <p>Gérer les demandes de devis</p>
          </Link>
          
          {user?.is_admin && (
            <Link to="/users" className="dashboard-card">
              <div className="card-icon">👥</div>
              <h2>Utilisateurs</h2>
              <p>Gérer les utilisateurs</p>
            </Link>
          )}
          
          <Link to="/profile" className="dashboard-card">
            <div className="card-icon">⚙️</div>
            <h2>Mon profil</h2>
            <p>Modifier mes informations</p>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;

